import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import './index.scss'
import App from './App'
import store from './config/store'
import { auth } from './action/auth'
import { updateAppLoading } from './action/app'
import { get_account } from './action/user'
import { connect, Provider } from 'react-redux'
import { ReactKeycloakProvider } from '@react-keycloak/web'

import keycloak from './keycloak'
import { bindActionCreators } from 'redux'
// import { getStorageTokens } from './utils/utilsSSO'

const sentryDSN = process.env.SENTRY_DSN

if (sentryDSN) {
  Sentry.init({
    dsn: sentryDSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['warn', 'error', 'debug', 'assert'],
      }),
    ],
  })
}

const IndexApp = (props) => {
  const initialOptions = {
    onLoad: 'check-sso',
    checkLoginIframe: false,
    flow: 'standard', // standard / implicit / hybrid
  }

  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      onTokens={(token) => {
        // if(!token || !token?.token && !location.pathname.includes('associate_screen'))
        //   keycloak.login({ redirectUri: window.location.href })
        //
        // const initialToken = getStorageTokens()
        props.auth(token)
      }}
      initOptions={initialOptions}
      onEvent={(event, _, __) => {
        if (event === 'onReady') props.updateAppLoading(false)
      }}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ReactKeycloakProvider>
  )
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({ auth, get_account, updateAppLoading }, dispatch),
  }
}

const IndexAppConnected = connect(null, mapDispatchToProps)(IndexApp)

const ReduxIndexApp = (props) => {
  return (
    <Provider store={store}>
      <IndexAppConnected {...props} />
    </Provider>
  )
}

ReactDOM.render(<ReduxIndexApp />, document.getElementById('root'))
